import uniAdminApi from "./api";

const transactionService = {
  // Supported filters per the /university-admin/transactions contract:
  // userEmail, startDate/endDate (ISO-8601), type, eventId, clubId.
  // `status` isn't part of that contract but is kept for the embedded
  // ledger widgets (UMTransactionList) that still rely on it.
  getTransactions: async ({ page = 0, size = 20, userEmail, startDate, endDate, status, type, eventId, clubId } = {}) => {
    // axios only drops null/undefined params, so falsy strings ("") must be
    // normalized here or they'd be sent as empty query params (e.g. `clubId=`).
    const res = await uniAdminApi.get("/university-admin/transactions", {
      params: {
        page,
        size,
        userEmail: userEmail || undefined,
        startDate: startDate || undefined,
        endDate: endDate || undefined,
        status: status || undefined,
        type: type || undefined,
        eventId: eventId || undefined,
        clubId: clubId || undefined,
      },
    });
    return res.data;
  },

  getTransactionById: async (id) => {
    const res = await uniAdminApi.get(`/university-admin/transactions/${id}`);
    return res.data;
  },
};

export default transactionService;
